<template>
    <div class="howTheGold">
        <div class="header">
            <div class="title">
                {{t('how_the_gold.title')}}
            </div>
            <div class="title_b">

            </div>
        </div>
        <div class="content">
            <div class="content_wrap">
                <div class="title1">
                    {{t('how_the_gold.title1')}}
                </div>
                <div class="content1 flc">
                    <div class="item fl">
                        <div class="img img1"></div>
                        <div class="r">
                            <div class="title"> {{t('how_the_gold.content1.desc1.text_1')}}</div>
                            <p class="desc1">  {{t('how_the_gold.content1.desc1.text_2')}}</p>
                        </div>
                    </div>

                    <div class="arrow"></div>

                    <div class="item fl">
                        <div class="img img2"></div>
                        <div class="r">
                            <div class="title"> {{t('how_the_gold.content1.desc2.text_1')}}</div>
                            <p class="desc1">  {{t('how_the_gold.content1.desc2.text_2')}}</p>
                        </div>
                    </div>

                    <div class="arrow"></div>

                    <div class="item fl">
                        <div class="img img3"></div>
                        <div class="r">
                            <div class="title"> {{t('how_the_gold.content1.desc3.text_1')}}</div>
                            <p class="desc1">  {{t('how_the_gold.content1.desc3.text_2')}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <p>{{t('how_the_gold.phone1')}}</p>
            <p>{{t('how_the_gold.phone2')}}</p>
        </div>
    </div>
</template>

<script>
import { onMounted } from "vue"
import { useI18n } from "vue-i18n"
export default {
  name:'HowTheGold',
  setup(){
    const { t } = useI18n()

    onMounted(()=>{
      document.title = t('how_the_gold.title')
    })

    return{
      t
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "./style.styl"
</style>